import moment from 'moment-timezone';
import { formatNumber } from '../../../common/money';
import { t } from '../../../../modules/infra/i18n';

export const format = (timezone) => (item) => {
  const row = {
    [t('reports:loan_repayment.columns.original_borrowed_total')]: formatNumber(item.loanAmountBorrowed),
    [t('reports:loan_repayment.columns.original_borrowed_date')]: moment
      .tz(item.loanRepaymentStartDate, timezone)
      .format('L'),
    [t('reports:loan_repayment.columns.repayment_rate')]: `%${item.loanRepaymentPercentage}`,
    [t('reports:loan_repayment.columns.amount_owed')]: formatNumber(item.loanAmountOwed),
  };

  if (item.loanAmountOwed !== 0) {
    if (item.loanRepaymentPercentage !== 0) {
      row[t('reports:loan_repayment.columns.expected_repayment_date')] = moment
        .tz(item.expectedRepaymentEndDate, timezone)
        .format('L');
      row[t('reports:loan_repayment.columns.repayment_status')] = t('reports:loan_repayment.status.ongoing');
    } else {
      row[t('reports:loan_repayment.columns.repayment_status')] = t('reports:loan_repayment.status.suspended');
    }
  } else {
    row[t('reports:loan_repayment.columns.repayment_status')] = t('reports:loan_repayment.status.complete');
  }
  return row;
};

const makeReport = (report, timezone) => {
  const withTimezone = format(timezone);
  return withTimezone(report);
};

export default makeReport;
